import React from 'react';
import { Outlet}  from 'react-router-dom';
import { connect } from 'react-redux';

const CallCenter = () => {
  return (
    <div className='h-100'>
      <Outlet />
    </div>
  );
};

const mapStateToProps = ({
  orders,
}) => ({
  isHeight: orders.isHeight
});

export default connect(
  mapStateToProps,
  null
)(CallCenter);
